module.exports = __webpack_public_path__ + "static/media/icon-feature-simple.41a18128.svg";